import { render } from "./menu-divider.vue?vue&type=template&id=531a0c19"
import script from "./menu-divider.vue?vue&type=script&lang=js"
export * from "./menu-divider.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\flash-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__